import { render, staticRenderFns } from "./RestsToCompensateCard.vue?vue&type=template&id=510ca648"
import script from "./RestsToCompensateCard.vue?vue&type=script&lang=js"
export * from "./RestsToCompensateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports